// extracted by mini-css-extract-plugin
module.exports = {"ConfirmAction":"ConfirmAction_ConfirmAction__1VYQF","Buttons":"ConfirmAction_Buttons__Iccp6"};